<!--
 * @Description: 底部申请开票组件
 * @Author: yeqing
 * @Date: 2021-9-7 17:35:30
 * @LastEditTime:
 * @LastEditors:
-->
<template>
  <div v-if="isVisible" class="apply-bottom-model w-100 cr-ai-center cr-jc-end">
    <div class="order cr-fs-lg">已选{{ orderNum }}个订单</div>
    <div class="total cr-fs-lg">总计:</div>
    <div class="money cr-text-amount">￥{{ totalMoney }}</div>
    <a-button type="primary" @click="handleAplly">申请开票</a-button>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    orderNum: {
      type: Number
    },
    totalMoney: {
      type: Number
    }
  },
  methods: {
    handleCancel() {
      // this.$emit('update:isVisible', false)
    },
    handleAplly() {
      // this.$emit('update:isVisible', false)
      this.$emit('onAplly')
    }
  },
  mounted() {
    // console.log(document.getElementsByClassName('ant-layout-sider-children')[0].offsetWidth)
  }
}
</script>

<style lang="less" scoped>
.apply-bottom-model {
  height: 60px;
  background: @cr-text-f;
  box-shadow: 0px -2px 7px -4px rgba(0, 0, 0, 0.12);
  position: fixed;
  bottom: 0;
  right: 0;
  padding-right: 10px;
  ::v-deep.ant-btn {
    border-radius: 3px !important;
  }
  .order {
    color: #4a4a4a;
    font-weight: bold;
    margin-right: 14px;
  }
  .total {
    color: #4a4a4a;
    width: 48px;
  }
  .money {
    font-size: 24px;
    font-weight: bold;
    margin-right: 40px;
  }
}
</style>
